import * as R from 'ramda'

const toUpperCase = (v) => v.toUpperCase()

class AdvancedXTab {
    constructor({
        id = undefined,
        rows = [],
        columns = [],
        filter = [],
        options = {
            columnPct: true,
            rowPct: false,
            cellN: false,
            totalColumnN: true,
            totalRowN: false,
            totalRowPct: true,
            avg: true,
            zScore: false,
            tTest: false,
            chiSquare: false,
        },
        name = 'Cross Tabbing',
    }) {
        this.id = id
        this.rows = rows.map(toUpperCase)
        this.columns = columns.map(toUpperCase)
        this.filter = filter
        this.options = options
        this.name = name
    }

    toJSON = () => ({
        id: this.id,
        name: this.name,
        rows: this.rows.map(toUpperCase),
        columns: this.columns.map(toUpperCase),
        filter: this.filter,
        options: this.options,
    })
}

export default AdvancedXTab
